<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="600px"
    :show-close="false"
    :close-on-click-modal="false"
    :destroy-on-close="true"
  >
    <el-form
      class="form"
      label-width="110px"
      ref="form"
      :model="form"
      :rules="rules"
      size="medium"
    >
      <el-form-item label="预计到岗日期" prop="on_board_time">
        <el-date-picker
          v-model="form.on_board_time"
          type="date"
          format="yyyy年MM月dd日"
          value-format="yyyy-MM-dd HH:mm"
          style="width:100%"
          placeholder="选择到岗日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="基本薪资" prop="basic_salary_lower">
        <el-input v-model="form.basic_salary_lower" placeholder="请输入金额" style="width:35%">
          <template slot="append">元</template>  
        </el-input>—<el-input v-model="form.basic_salary_upper" placeholder="请输入金额" style="width:35%">
          <template slot="append">元</template>
        </el-input>
        <el-select
          v-model="form.basic_salary_period"
          style="width:25%;margin-left:5px;"
        >
          <el-option label="小时" :value="1"></el-option>
          <el-option label="天" :value="2"></el-option>
          <el-option label="周" :value="3"></el-option>
          <el-option label="月" :value="4"></el-option>
          <el-option label="次" :value="5"></el-option>
          <el-option label="其他" value="6"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="结算方式" prop="settlement_method">
        <el-radio-group v-model="form.settlement_method">
          <el-radio style="margin-top:15px" :label="1">日结</el-radio>
          <el-radio style="margin-top:15px" :label="2">周结</el-radio>
          <el-radio style="margin-top:15px" :label="3">月结</el-radio>
          <el-radio style="margin-top:15px" :label="4">完工结</el-radio>
          <el-radio style="margin-top:15px" :label="5">其他</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="提成类型" prop="bonus_type">
        <el-radio-group v-model="form.bonus_type">
          <el-radio style="margin-top:15px" :label="1">无提成</el-radio>
          <el-radio style="margin-top:15px" :label="2">业绩提成</el-radio>
          <el-radio style="margin-top:15px" :label="3">计件提成</el-radio>
          <el-radio style="margin-top:15px" :label="4">自定义</el-radio>
        </el-radio-group>
        <el-input 
          v-if="form.bonus_type && form.bonus_type!==1" 
          v-model="form.bonus_value" 
          :placeholder="form.bonus_type===2?'请输入提成比例':form.bonus_type===4?'最多输入30个字':'请输入金额'" 
          style="width:85%;margin-top:20px;" 
        >
          <template slot="append" v-if="form.bonus_type===2||form.bonus_type===3">{{form.bonus_type===2?'%':'元/件'}}</template>  
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="resetForm()">取 消</el-button>
      <el-button type="primary" @click="submitForm('form')">确 认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import BaseDialog from "../BaseDialog";
import Api from "@/api"
export default {
  name: 'PartTimeOfferDialog',
  extends: BaseDialog,
  data() {
    return {
      title: '录用信息确认',
      ids: '',
      type: 1, // 1 录用 2 到岗
      form: {
        on_board_time:'',
        basic_salary_lower: '',
        basic_salary_upper: '',
        basic_salary_period: '',
        settlement_method: '',
        bonus_type: '',
        bonus_value: '',
      },
      rules: {
        on_board_time: [ { required: true, message: "选择到岗时间", trigger: "change" } ],
        basic_salary_lower: [ { required: true, message: "请填写基本薪资", trigger: "blur" } ],
        basic_salary_upper: [ { required: true, message: "请填写基本薪资", trigger: "blur" } ],
        basic_salary_period: [ { required: true, message: "请填写基本薪资", trigger: "change" } ],
        settlement_method: [ { required: true, message: "请选择结算方式", trigger: "change" } ],
        bonus_type: [ { required: true, message: "请选择提成类型", trigger: "change" } ],
      }
    }
  },
  mounted() {
    
  },
  methods: {
    open(records, type) {
      this.visible = true
      this.type = type
      this.title =  type + '信息确认'
      if(records.length) {
        let ids = []
        records.forEach( x => {
          ids.push(x.id)
        })
        this.ids = ids.join(',')
      } else {
        this.ids = records.id
      } 
    },
    submitForm(formName) {
      this.$refs[formName].validate( async valid => {
        console.log(this.form);
        if (valid) {
          this.form.ids = this.ids
          let api = this.type === '录用' ? 'confirmEmploy' : 'confirmEntry'
          let res = await Api.post[api](this.form)
          if(res) {
            this.$message.success('成功')
            this.close();
            this.callback && this.callback()
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.visible = false
    }
  },
}
</script>

<style lang="scss" scoped>
.form {
  width: 90%;
}
::v-deep .el-input-group__append, .el-input-group__prepend {
  padding: 0 6px;
}
</style>